import React from 'react'


const styles = {
  root: {
    paddingBottom: '15px',
    height: '50px',
    width: '100%',
    position: 'relative',
  },
  diamond: {
    height: '50px',
    width: 'auto',
    position: 'absolute',
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    top: '0',
  },
  content: {
    position: 'absolute',
    color: '#f2881d',
    top: '15px',
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}

class Diamond extends React.Component {

  render() {
    return (
      <div style={styles.root}>
        <img src={`${process.env.PUBLIC_URL}/img/mission_diamond.png`} alt="" style={styles.diamond} />
        <div style={styles.content}>{(this.props.credits||0).toLocaleString()}</div>
      </div>
    )
  }
}


export default Diamond



// WEBPACK FOOTER //
// ./src/components/CampaignShow/MissionIndex/Diamond/index.jsx